import { render } from "./ExamsArchive.vue?vue&type=template&id=6964cf2a"
import script from "./ExamsArchive.vue?vue&type=script&lang=js"
export * from "./ExamsArchive.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__